<template>
  <v-dialog
     v-bind="$attrs"
     v-model="showDialog"
   >
     <template v-slot:default="dialog">
       <v-card color="primary" dark>
         <v-card-text align="center">
           <h3 style="color:white">{{title}}</h3>
           <v-progress-linear
             indeterminate
             color="white"
             class="mb-0"
           ></v-progress-linear>
         </v-card-text>
       </v-card>
     </template>
   </v-dialog>
</template>
<script>
  export default {
    name: 'MaterialLoading',
    props: {
      title: {
        type: String,
        default: '加载中... 请稍等'
      },
      loading: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        showDialog: this.loading
      }
    },
    watch: {
      showDialog (val) {
        this.$emit('on-loading-change', val)
      },
      loading (val) {
        this.showDialog = val
      }
    }
  }
</script>

<style lang="sass" scoped>
  .dialog-toolbat-title
</style>
